// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"524":"app","817":"preload-warning"}[chunkId] + "." + {"524":"a49343c9","817":"83da7434"}[chunkId] + ".css";
};